import FloatSelect from './float_select';

export default class FloatProvince extends FloatSelect {
  constructor() {
    super();

    document.addEventListener('float-country:change', (event) => {
      this.handleCountryChange(event);
    });

    this.autocomplete = "address-level1"

    this.validators = [
      {
        ...this.validators[0],
      },
      {
        key: 'valueMissing',
        message: () => 'Please select a province',
        isValid: () => {
          if (!this.required) return true;

          if (!this.hasInteracted && !this._dirty) return true;

          if (!this.options || this.options.length === 0) {
            return true;
          }

          const validOptions = this.options.filter(option => !option.disabled && !option.hidden);
          if (validOptions.length === 0) {
            return true;
          }

          const selectedOption = this.options?.find(
            (option) => option.value === this.select?.value
          );

          return (
            selectedOption &&
            !selectedOption.disabled &&
            !selectedOption.hidden &&
            selectedOption.value !== ''
          );
        },
      },
    ];
  }

  get customerProvince() {
    return this.getAttribute('customer-province');
  }

  handleCountryChange(event) {
    const country = event.detail?.country;
    if (!country) return;

    const provinces = this.getProvincesForCountry(country);
    this.updateProvinceOptions(provinces);
  }

  getProvincesForCountry(country) {
    if (!window.countryProvinceData || !window.countryProvinceData[country]) {
      return [];
    }
    return window.countryProvinceData[country].provinces || [];
  }

  updateProvinceOptions(provinces) {
    const currentValue = this.value;

    if (!provinces || !provinces.length) {
      this.options = [];
      if (this.select) {
        this.select.value = '';
      }
      this.value = '';
      this.updateValidity();
      this.setInvalidState();
      return;
    }

    const hasValidSelection = this.customerProvince || (currentValue && currentValue !== '');

    this.options = [
      {
        label: 'Province',
        value: '',
        disabled: true,
        hidden: true,
        selected: !hasValidSelection,
      },
      ...provinces.map((province) => ({
        label: province,
        value: province,
        selected: (this.customerProvince === province) || (currentValue === province && currentValue !== ''),
      })),
    ];

    if (this.customerProvince && provinces.includes(this.customerProvince)) {
      this.value = this.customerProvince;
    } else if (currentValue && currentValue !== '' && provinces.includes(currentValue)) {
      this.value = currentValue;
    } else {
      this.value = '';
      if (this.select) {
        this.select.value = '';
      }
    }

    if (this.hasInteracted) {
      this.updateValidity();
      this.setInvalidState();
    }
    this.requestUpdate();
  }

  handleFocus() {
    super.handleFocus();

    if (this.options.length > 1) {
      return;
    }

    const countrySelect = this.closest('form').querySelector('float-country');

    if (!countrySelect) {
      return;
    }

    const countrySelectedValue = countrySelect.select.value;

    if (!countrySelectedValue) {
      return;
    }

    const provinces = this.getProvincesForCountry(countrySelectedValue);

    if (!provinces || !provinces.length) {
      this.options = [];
      this.updateValidity();
      this.setInvalidState();
      return;
    }

    const currentValue = this.value;
    const hasValidSelection = currentValue && currentValue !== '';

    this.options = [
      {
        label: 'Province',
        value: '',
        disabled: true,
        hidden: true,
        selected: !hasValidSelection,
      },
      ...provinces.map((province) => ({
        label: province,
        value: province,
        selected: currentValue === province && currentValue !== '',
      })),
    ];

    if (currentValue && currentValue !== '' && provinces.includes(currentValue)) {
      this.value = currentValue;
      if (this.select) {
        this.select.value = currentValue;
      }
    } else {
      this.value = '';
      if (this.select) {
        this.select.value = '';
      }
    }

    if (this.hasInteracted) {
      this.updateValidity();
      this.setInvalidState();
      this.requestUpdate();
    }
  }
}

window.customElements.get('float-province') ||
  window.customElements.define('float-province', FloatProvince);
